const LOCAL = 'local' as const
const TRAINING = 'training' as const
const SANDBOX = 'sandbox' as const
const NONPROD = 'nonprod' as const
const BETA = 'beta' as const
const PROD = 'prod' as const

type ServerEnv =
  | typeof LOCAL
  | typeof BETA
  | typeof TRAINING
  | typeof SANDBOX
  | typeof NONPROD
  | typeof PROD

// Never use in React. Even though React does a SSR first pass
// the variables won't be set once the components make it to the front end
function getServerEnv(): ServerEnv {
  if (process.env.SERVER_ENV === 'training') {
    return TRAINING
  }
  if (process.env.SERVER_ENV === 'sandbox') {
    return SANDBOX
  }
  if (process.env.SERVER_ENV === 'nonprod') {
    return NONPROD
  }
  if (process.env.SERVER_ENV === 'beta') {
    return BETA
  }
  if (process.env.SERVER_ENV === 'prod') {
    return PROD
  }
  return LOCAL
}

export type { ServerEnv }
export { LOCAL, TRAINING, SANDBOX, NONPROD, BETA, PROD, getServerEnv }
